import { ChangeEvent, useState } from "react";
import { Form } from "react-bootstrap";
import TextField from "@components/FormsV2/TextField/TextField";
import RequiredReactSelect from "@components/FormsV2/RequiredReactSelect/RequiredReactSelect";
import { DOCUMENT_TYPE_OPTIONS } from "../types";
import type { AttachmentTypeFormValues } from "../types";

export interface AttachmentTypeFormProps {
  id: string;
  initialValues: AttachmentTypeFormValues;
  isSubmitting: boolean;
  onSubmit: (values: AttachmentTypeFormValues) => void;
}

export const AttachmentTypeForm = ({
  id,
  initialValues,
  isSubmitting,
  onSubmit,
}: AttachmentTypeFormProps): JSX.Element => {
  const [values, setValues] = useState<AttachmentTypeFormValues>(initialValues);

  const set = <K extends keyof AttachmentTypeFormValues>(
    key: K,
    v: AttachmentTypeFormValues[K]
  ) => setValues((prev) => ({ ...prev, [key]: v }));

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSubmit(values);
  };

  const selectedType =
    DOCUMENT_TYPE_OPTIONS.find((o) => o.value === values.documentType) ??
    undefined;

  return (
    <Form id={id} data-testid={id} onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <Form.Label htmlFor="attachment-type-name">Name</Form.Label>
          <TextField
            label={null}
            id="attachment-type-name"
            value={values.name}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              set("name", e.target.value)
            }
            required
          />
        </div>
        <div className="col-sm-3">
          <RequiredReactSelect
            label="Document Type"
            value={selectedType}
            onChange={(opt: any) => set("documentType", opt?.value ?? "")}
            options={DOCUMENT_TYPE_OPTIONS}
            placeholder="Select…"
            required
          />
        </div>
      </div>
    </Form>
  );
};

export default AttachmentTypeForm;
